import React from 'react';
import { Link } from 'react-router-dom';

const CGU = () => {

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" 
         style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #A855F7 30%, #EC4899 60%, #F97316 100%)' }}>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex flex-col items-center mb-4">
              <img 
                src="/logo-alo-advance.png" 
                alt="ALO ADVANCE" 
                className="h-24 w-24 drop-shadow-lg mb-2"
              />
              <p className="text-gray-600 text-sm font-semibold italic">Parce que Nous prévoyons Vos imprévus</p>
            </div>
            <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-orange-500 mb-2">
              Conditions Générales d'Utilisation
            </h1>
            <p className="text-gray-600">ALO ADVANCE - ALO FINANCES</p>
            <p className="text-sm text-gray-500">Dernière mise à jour : Octobre 2025</p>
          </div>

          {/* Contenu */}
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">1. Présentation du service</h2>
              <p className="mb-2">
                ALO ADVANCE est une plateforme digitale développée et exploitée par <strong>ALO FINANCES</strong>, 
                société de droit guinéen, permettant aux entreprises de gérer les avances sur salaire de leurs employés 
                de manière simple, sécurisée et transparente.
              </p>
              <p>
                En utilisant ALO ADVANCE, vous acceptez d'être lié par les présentes Conditions Générales d'Utilisation (CGU).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">2. Définitions</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Plateforme</strong> : L'application web et mobile ALO ADVANCE</li>
                <li><strong>Utilisateur</strong> : Toute entreprise ou employé inscrit sur la plateforme</li>
                <li><strong>Entreprise</strong> : Personne morale s'inscrivant pour utiliser les services</li>
                <li><strong>Employé</strong> : Salarié d'une entreprise cliente bénéficiant du service</li>
                <li><strong>ALO FINANCES</strong> : Éditeur et exploitant de la plateforme</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">3. Inscription et création de compte</h2>
              <h3 className="font-semibold text-purple-600 mb-2">3.1 Inscription des entreprises</h3>
              <p className="mb-2">
                L'inscription est réservée aux entreprises légalement constituées en République de Guinée. 
                L'entreprise doit fournir des informations exactes, complètes et à jour.
              </p>
              <h3 className="font-semibold text-purple-600 mb-2 mt-3">3.2 Validation du compte</h3>
              <p className="mb-2">
                Après inscription, ALO FINANCES procède à une vérification administrative avant activation du compte. 
                L'entreprise devra s'acquitter des frais de déploiement annuels :
              </p>
              <ul className="list-disc pl-6 space-y-1 mb-2">
                <li><strong>De 0 à 50 employés :</strong> 3.000.000 GNF (forfait annuel)</li>
                <li><strong>Au-delà de 50 employés :</strong> 3.000.000 GNF + 10.000 GNF par employé supplémentaire</li>
              </ul>
              <p className="text-sm text-gray-600">
                <strong>Exemples :</strong> 30 employés = 3.000.000 GNF | 75 employés = 3.250.000 GNF | 100 employés = 3.500.000 GNF
              </p>
              <h3 className="font-semibold text-purple-600 mb-2 mt-3">3.3 Sécurité du compte</h3>
              <p>
                L'utilisateur est responsable de la confidentialité de ses identifiants de connexion et de toutes 
                les activités effectuées sous son compte.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">4. Services proposés</h2>
              <h3 className="font-semibold text-purple-600 mb-2">4.1 Pour les entreprises</h3>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>Gestion des employés et de leurs avances sur salaire</li>
                <li>Suivi en temps réel des transactions</li>
                <li>Tableaux de bord et rapports financiers</li>
                <li>Gestion du solde prépayé</li>
              </ul>
              <h3 className="font-semibold text-purple-600 mb-2">4.2 Pour les employés</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Demande de paiement direct sur wallet mobile money</li>
                <li>Consultation de l'historique des paiements</li>
                <li>Suivi du solde disponible</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">5. Obligations des utilisateurs</h2>
              <h3 className="font-semibold text-purple-600 mb-2">5.1 Usage conforme</h3>
              <p className="mb-2">
                L'utilisateur s'engage à utiliser la plateforme de manière conforme aux lois guinéennes 
                et aux présentes CGU. Sont notamment interdits :
              </p>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>Les tentatives de fraude ou de manipulation</li>
                <li>L'usurpation d'identité</li>
                <li>La diffusion de contenus illicites</li>
                <li>Les tentatives de piratage ou d'intrusion</li>
              </ul>
              <h3 className="font-semibold text-purple-600 mb-2">5.2 Exactitude des informations</h3>
              <p>
                L'utilisateur garantit l'exactitude et la véracité des informations communiquées à ALO FINANCES.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">6. Tarification et paiement</h2>
              <p className="mb-2">
                <strong>6.1 Frais de déploiement annuels :</strong>
              </p>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>De 0 à 50 employés : 3.000.000 GNF par an (forfait)</li>
                <li>Au-delà de 50 employés : 3.000.000 GNF + 10.000 GNF par employé supplémentaire</li>
              </ul>
              <p className="mb-2">
                <strong>6.2 Commissions :</strong> ALO FINANCES prélève une commission sur chaque transaction de paiement direct.
              </p>
              <p>
                <strong>6.3 Modalités de paiement :</strong> Les paiements s'effectuent via mobile money ou virement bancaire.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">7. Communications et notifications</h2>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-lg mb-3">
                <p className="font-semibold text-orange-800 mb-2">📱 Autorisation de communication</p>
                <p className="text-orange-700">
                  En acceptant les présentes CGU, l'utilisateur autorise expressément <strong>ALO FINANCES</strong> 
                  à lui envoyer, aux numéros de téléphone et adresses e-mail renseignés :
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1 text-orange-700">
                  <li>Des notifications liées à l'utilisation d'ALO ADVANCE</li>
                  <li>Des informations sur d'autres produits et services d'ALO FINANCES</li>
                  <li>Des communications promotionnelles et commerciales</li>
                  <li>Toute autre information qu'ALO FINANCES juge nécessaire ou pertinente</li>
                </ul>
                <p className="mt-2 text-sm text-orange-600">
                  L'utilisateur peut se désinscrire de ces communications à tout moment en contactant le service client.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">8. Responsabilités</h2>
              <h3 className="font-semibold text-purple-600 mb-2">8.1 Responsabilité d'ALO FINANCES</h3>
              <p className="mb-2">
                ALO FINANCES met tout en œuvre pour assurer la disponibilité et la sécurité de la plateforme. 
                Toutefois, ALO FINANCES ne peut être tenue responsable :
              </p>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>Des interruptions de service pour maintenance</li>
                <li>Des cas de force majeure</li>
                <li>Des défaillances des opérateurs de télécommunications</li>
              </ul>
              <h3 className="font-semibold text-purple-600 mb-2">8.2 Responsabilité de l'utilisateur</h3>
              <p>
                L'utilisateur est seul responsable de l'utilisation qu'il fait de la plateforme et des conséquences 
                de cette utilisation.
              </p>
              <h3 className="font-semibold text-purple-600 mb-2 mt-4">8.3 Responsabilité exclusive de l'entreprise sur ses employés</h3>
              <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg mt-2">
                <p className="font-semibold text-red-800 mb-2">⚠️ Clause importante</p>
                <p className="text-red-700 mb-2">
                  <strong>L'entreprise cliente est entièrement et exclusivement responsable de la gestion de ses employés</strong>, 
                  incluant mais ne se limitant pas à :
                </p>
                <ul className="list-disc pl-6 space-y-1 text-red-700 mb-2">
                  <li>La création, modification et suppression des comptes employés</li>
                  <li>La gestion des statuts des employés (actif, suspendu, licencié, etc.)</li>
                  <li>La désactivation des comptes en cas de départ, licenciement ou fin de contrat</li>
                  <li>Le contrôle d'accès aux services de paiement direct</li>
                </ul>
                <p className="text-red-700 font-semibold mb-2">
                  <strong>ALO FINANCES n'intervient EN AUCUN CAS dans la gestion interne des employés de l'entreprise.</strong>
                </p>
                <p className="text-red-700 mb-2">
                  En conséquence, <strong>toute transaction effectuée par un employé, quel que soit son statut interne 
                  (actif, suspendu, licencié, démissionnaire, etc.), est à la charge financière exclusive de l'entreprise</strong>, 
                  tant que le compte de l'employé n'a pas été formellement désactivé par l'entreprise sur la plateforme.
                </p>
                <p className="text-red-600 text-sm mt-3">
                  <strong>Exemple :</strong> Si un employé licencié effectue une transaction avant que l'entreprise 
                  ne désactive son compte, cette transaction sera facturée à l'entreprise. L'entreprise ne peut tenir 
                  ALO FINANCES responsable de telles transactions.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">9. Propriété intellectuelle</h2>
              <p>
                Tous les éléments de la plateforme (logos, textes, graphismes, code source) sont la propriété 
                exclusive d'ALO FINANCES et sont protégés par les lois sur la propriété intellectuelle.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">10. Résiliation</h2>
              <p className="mb-2">
                <strong>10.1 Résiliation par l'utilisateur :</strong> L'utilisateur peut fermer son compte à tout moment.
              </p>
              <p>
                <strong>10.2 Résiliation par ALO FINANCES :</strong> En cas de non-respect des CGU, ALO FINANCES 
                se réserve le droit de suspendre ou fermer le compte sans préavis.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">11. Modification des CGU</h2>
              <p>
                ALO FINANCES se réserve le droit de modifier les présentes CGU à tout moment. 
                Les utilisateurs seront informés des modifications par notification sur la plateforme.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">12. Loi applicable et juridiction</h2>
              <p>
                Les présentes CGU sont régies par le droit guinéen. Tout litige sera soumis aux tribunaux compétents de Conakry.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">13. Contact</h2>
              <p className="mb-2">Pour toute question concernant les présentes CGU :</p>
              <div className="bg-purple-50 p-4 rounded-lg">
                <p><strong>ALO FINANCES</strong></p>
                <p>Email : contact@alofinances.com</p>
                <p>Téléphone : +224 XXX XXX XXX</p>
                <p>Adresse : Conakry, République de Guinée</p>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-200 text-center space-x-4">
            <Link
              to="/login"
              className="inline-block px-6 py-3 bg-gradient-to-r from-purple-600 to-orange-500 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-orange-600 transition-all"
            >
              Retour à la connexion
            </Link>
            <Link
              to="/register"
              className="inline-block px-6 py-3 border-2 border-purple-600 text-purple-600 font-semibold rounded-lg hover:bg-purple-50 transition-all"
            >
              S'inscrire
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGU;
